import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'

import SpeakerNotes from '@mui/icons-material/SpeakerNotes';
import { Button } from '@mui/material';

class ToggleContainer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			open: props.open || false,
		}
	}

	componentDidMount () {
		const id = this.props.id;
		document.getElementById(id).addEventListener(`toggler-${id}`, this.toggleOpen.bind(this), false);
		document.getElementById(id).addEventListener(`toggler-open-${id}`, this.toggleOpen.bind(this), false);
	}

	toggleOpen () {
		this.setState({ open: !this.state.open });
	}

	render () {
		return (
			<div hidden={!this.state.open} {...this.props}>
				{this.props.children}
			</div>
		);
	}
}

ToggleContainer.propTypes = {
	id: PropTypes.string.isRequired,
	active: PropTypes.bool
}

class ToggleTrigger extends Component {
	constructor(props) {
		super(props);
		this.state = {
			active: props.active || false,
			label: props.label,
			staysopen: props.staysopen === 'true',
		}
	}

	componentDidMount () {
		const id = this.props.id;
		const triggerElement = document.getElementById(id);
		if (triggerElement) {
			triggerElement.addEventListener(`toggler-close-${id}`, this.toggleActive.bind(this), false);
		}
		if (this.props.active) {
			this.toggleActive();
		}
	}

	toggleActive () {
		const targetId = this.props.targetId;
		if (!this.state.active || (this.state.active && !this.state.staysopen)) {
			this.setState({
				active: !this.state.active
			}, () => document.getElementById(targetId).dispatchEvent(new Event(`toggler-${targetId}`)));
		}
	}

	open () {
		const targetId = this.props.targetId;
		if (!this.state.active || (this.state.active && !this.state.staysopen)) {
			this.setState({
				active: !this.state.active
			}, () => document.getElementById(targetId).dispatchEvent(new Event(`toggler-open-${targetId}`)));
		}
	}

	render () {
		// dispatch is filtered out; it will trigger a React warning
		const { targetId, active, dispatch, ...filterProps } = this.props; // eslint-disable-line no-unused-vars

		let label

		if (this.props.children && this.state.label === '') {
			label = ''
		} else {
			label = !this.state.label
				? this.props.t.notes
				: this.state.label
		}

		return (
			<Button
				{...filterProps}
				variant="contained"
				style={{ marginTop: 8 }}
				onClick={this.open.bind(this)}
				color={this.state.active ? "primary" : "secondary"}
			>
				{ this.props.children }
				{this.state.label === this.props.t.notes && !this.state.label &&
					<SpeakerNotes style={{ marginRight: 8, marginBottom: -2 }} />
				}
				{ label }
			</Button>
		);
	}
}

ToggleTrigger.propTypes = {
	targetId: PropTypes.string.isRequired
}

function mapStateToProps (state) {
	const { t } = state.store
	return { t }
}
const ConnectedToggleTrigger = connect(mapStateToProps)(ToggleTrigger)

export { ToggleContainer, ConnectedToggleTrigger as ToggleTrigger }
